<template>
  <div class="header-ios-safe">
    <header class="bg-white text-primary">
      <QToolbar>
        <QBtn round color="primary" icon="icon-f-arrow-left" dense flat @click="onClickBack" />
        <QToolbarTitle>
          {{ t("CORE.DEVELOPER.@DEVELOPER") }}
        </QToolbarTitle>
      </QToolbar>
    </header>
    <DeveloperToolsList
      v-if="appInfos && environnementInfos"
      :application-infos="appInfos"
      :environment-infos="environnementInfos"
      @copy="copyHandler"
    />
  </div>
</template>

<script setup>
  // @ts-check
  import { ref, inject, onMounted } from "vue";
  import { copyToClipboard } from "quasar";

  import { useRouter } from "vue-router";
  import { useI18n } from "vue-i18n";
  import { ETAB_ROUTES } from "@etab/config";
  import { Applications, GetApplicationInfos, GetEnvironmentInfos } from "@extracadabra/core-v2";
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import DeveloperToolsList from "@core/components/common/DeveloperToolsList.component.vue";

  const router = useRouter();
  const { t } = useI18n();

  const appInfos = ref(null);
  const environnementInfos = ref(null);

  const { developerToolsRepository } = inject("repositories");

  const onClickBack = () => {
    router.push({ name: ETAB_ROUTES.userMenu.root.name }).catch((suppressedError) => {});
  };

  onMounted(async () => {
    appInfos.value = await new GetApplicationInfos(developerToolsRepository).execute(Applications.Etablissement);
    environnementInfos.value = await new GetEnvironmentInfos(developerToolsRepository).execute();
  });

  const copyHandler = (text) => {
    try {
      copyToClipboard(text);
      NotificationsManager.info({ message: `${text} copié` });
    } catch (error) {
      NotificationsManager.error(error);
    }
  };
</script>
